<template>
  <div
    :class="{ 'top-[220px]': mobileFiltersActive }"
    class="fixed inset-x-0 bottom-0 flex h-[60px] items-center bg-white px-4 shadow-[0_-3px_6px_0px_#1413141A] tablet:hidden"
  >
    <div class="flex flex-1 items-center">
      <button class="btn-link-neutral-l w-full flex-1" @click="toggleMobileFilters">
        <span class="mr-1">{{ $t('job_list.sidebar.filter_mobile') }}</span>

        <span v-if="selectedFiltersCount" class="text-grey-600"> ({{ selectedFiltersCount }}) </span>
      </button>

      <img src="~/assets/images/arrow-up-black.svg" class="w-3.5" :class="{ 'rotate-180': mobileFiltersActive }" />
    </div>
  </div>

  <div class="flex flex-col bg-black p-4 laptop:items-center">
    <h2 class="mb-6 text-headline-l text-grey-50 tablet:hidden">
      {{ $t('job_list.sidebar.new_job') }}
    </h2>

    <h2 class="mb-4 text-headline-xs text-grey-50">
      {{ $t('job_list.sidebar.new_job_description') }}
    </h2>

    <div class="flex gap-2">
      <NuxtLink :to="jobsHrPaths.newJob({ locale })" class="btn-primary-color-s mt-2 laptop:mt-8">
        {{ $t('job_list.sidebar.new_job') }}
      </NuxtLink>

      <img src="~/assets/images/new-job-button-arrows.svg" class="mb-2 hidden w-9 object-contain laptop:block" />
    </div>
  </div>

  <div
    :class="{
      'fixed inset-x-0 top-[280px] bottom-0 !block overflow-y-auto': mobileFiltersActive,
    }"
    class="hidden space-y-5 border border-grey-300 bg-white p-4 tablet:mt-4 tablet:block"
  >
    <JobListFacets
      v-if="categoryFacets.length"
      :title="$t('job_list.sidebar.category_filter').toString()"
      facet-type="category"
      :facets="categoryFacets"
      :translated="true"
    />

    <JobListFacets
      v-if="locationFacets.length"
      :title="$t('job_list.sidebar.location_filter').toString()"
      facet-type="location"
      :facets="locationFacets"
      :translated="false"
    />

    <JobListFacets
      v-if="experienceFacets.length"
      :title="$t('job_list.sidebar.experience_filter').toString()"
      facet-type="experience"
      :facets="experienceFacets"
      :translated="true"
    />

    <JobListFacets
      v-if="locationOptionFacets?.length"
      :title="$t('job_list.sidebar.location_option_filter').toString()"
      facet-type="locationOption"
      :facets="locationOptionFacets"
      :translated="true"
    />
  </div>
</template>

<script setup lang="ts">
import { jobsHrPaths } from '@ramp106/omrjs-routing'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

import JobListFacets from '@/components/JobListFacets.vue'

import { NuxtLink } from '#components'
import { useSelectedFacetFiltersFromQuery } from '~/composables/useSelectedFacetFiltersFromQuery'
import type { SearchFacetFragment } from '~/gql/jobs/types.generated'

interface JobListSidebarProps {
  locationFacets: SearchFacetFragment[]
  categoryFacets: SearchFacetFragment[]
  experienceFacets: SearchFacetFragment[]
  locationOptionFacets: SearchFacetFragment[]
}

defineProps<JobListSidebarProps>()

const { locale } = useI18n()
const { selectedFacetFiltersFromQuery } = useSelectedFacetFiltersFromQuery()

const mobileFiltersActive = ref(false)

const selectedFiltersCount = computed(() => {
  const { categories, locations, experiences, locationOptions } = selectedFacetFiltersFromQuery.value

  return categories.length + locations.length + experiences.length + locationOptions.length
})

const toggleMobileFilters = () => {
  mobileFiltersActive.value = !mobileFiltersActive.value
}
</script>
